import { createIcon } from '@chakra-ui/react';
export const CheckIcon = createIcon({
    displayName: 'RadioCheckIcon',
    viewBox: '0 0 24 24',
    d: 'M20.4375 6.52344C20.8281 6.91406 20.8281 7.5 20.4375 7.85156L10.125 18.1641C9.77344 18.5547 9.1875 18.5547 8.83594 18.1641L3.52344 12.8516C3.13281 12.5 3.13281 11.9141 3.52344 11.5234C3.875 11.1719 4.46094 11.1719 4.8125 11.5234L9.5 16.2109L19.1484 6.52344C19.5 6.17188 20.0859 6.17188 20.4375 6.52344Z',
});
//# sourceMappingURL=check-icon.js.map